"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseItem = void 0;
var LicenseItem;
(function (LicenseItem) {
    LicenseItem["KRAVAG"] = "KRAVAG";
    LicenseItem["SPEDION"] = "SPEDION";
    LicenseItem["CARGOFUEL"] = "CARGOFUEL";
    LicenseItem["PLATFORM_SCIENCE"] = "PLATFORM_SCIENCE";
})(LicenseItem || (exports.LicenseItem = LicenseItem = {}));
//# sourceMappingURL=licenseItem.js.map